module.exports = __webpack_public_path__ + "img/man-avatar.65ef74d3.png";